<!-- 基本信息-服务信息 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header  flex flexJc-sb">
        <div class="head-title borderB">
          <div class="text">基本信息-服务信息</div>
        </div>
        <el-button size="mini" @click="goBack" icon="el-icon-back"
          >返回</el-button
        >
      </div>
      <div class="content">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="serveList"
          style="width: 100%"
        >
          <el-table-column prop="id" label="#"> </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="age" label="年龄"> </el-table-column>
          <el-table-column prop="relation" label="关系"> </el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              <span>{{ scope.row.sex | filterNum('男', '女') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="health" label="身体状况"> </el-table-column>
          <el-table-column prop="idcard" label="身份证号"> </el-table-column>
          <el-table-column prop="address" label="地址" width="210">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetMemberListByUid } from '@/api/clientManage'
export default {
  name: '',
  props: [''],
  data() {
    return {
      serveList: [], // 列表
      routeData: '' // 页面传参
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    if (this.$route.query.info !== undefined) {
      this.routeData = JSON.parse(this.$Base64.decode(this.$route.query.info))
      console.log(this.routeData)
      this.GetBUserList()
    }
  },

  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 接口
    // 获取用户的成员信息
    GetBUserList() {
      apiGetMemberListByUid({
        uids: this.routeData.uids
      }).then(res => {
        if (res.status === 0) {
          this.serveList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  padding: 0 10px;
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 50px;
    .text {
      text-align: left;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 172px);
    /deep/ .el-table {
      overflow: auto;
      height: calc(100vh - 192px);
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
</style>
